import script from "./RegisterForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegisterForm.vue?vue&type=script&lang=ts&setup=true"

import "./RegisterForm.vue?vue&type=style&index=0&id=33d8772c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33d8772c"]])

export default __exports__